import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, Box, Typography, Divider } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import LoginSuccessModal from '@/components/pages/Login/modals/LoginSuccessModal';
import { sendWelcomeEmail } from '@/services/emailService';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUser } from '@/redux/actions/userActions';
import { Link } from 'react-router-dom';
import Label from '@/components/form/Label/Label';

const SearchBar = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'margt60 align-items-end'}>
      <i class="fa fa-chevron-left" onClick={onBack}></i>
      <Label className={'fontWhite text-12 margl10'} onClick={onBack}>
        {languageData === 'EN' ? 'Return to homepage' : 'Volver al inicio'}
      </Label>
    </FlexContainer>
  );
};

const SignUpForm = props => {
  const {
    initialValues,
    onSubmit,
    onGoogleLogin,
    loading,
    languageData,
    onRegister,
    error,
    googleError,
    success,
    validationSchema,
  } = props;
  const [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSuccess = async credentialResponse => {
    try {
      const idToken = credentialResponse.credential;

      console.log('ID Token de Google:', idToken);

      const base64Url = idToken.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join(''),
      );

      const googleUserDetails = JSON.parse(jsonPayload);

      const tokenData = await onGoogleLogin({
        email: googleUserDetails.email,
        googleToken: idToken,
      });

      console.log('Token OAuth recibido:', tokenData);

      const userData = {
        name: googleUserDetails?.name,
        lastName: '',
        email: googleUserDetails?.email,
        user_id: tokenData?.user_details?.user_id || 2,
        google: true,
      };

      if (tokenData?.isFirstGoogleLogin) {
        const templateParams = {
          user_name: userData.name,
          user_email: userData.email,
          reply_to: userData.email,
          copy_to: 'sistemas@popnest.org',
          message: 'Estimado usuario, sea bienvenido a Popnest',
        };

        sendWelcomeEmail(templateParams)
          .then(() => console.log('Email de bienvenida enviado correctamente'))
          .catch(err =>
            console.error('Error enviando email de bienvenida:', err),
          );
      }

      dispatch(setUser(userData));

      localStorage.setItem('user', JSON.stringify(userData));
      localStorage.setItem('access_token', tokenData.access_token);
      localStorage.setItem('refresh_token', tokenData.refresh_token);
      localStorage.setItem(
        'auth_data',
        JSON.stringify({
          token_type: tokenData.token_type,
          expires_in: tokenData.expires_in,
          scope: tokenData.scope,
        }),
      );
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    } catch (error) {
      console.error('Error en login con Google:', error);
    }
  };

  const handleError = () => {
    console.log('Login Failed');
  };

  return (
    <FlexContainer className={'flex-column margb20 height-610px'}>
      {!success && (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ isSubmitting, errors, touched }) => (
            <FlexContainer className={'flex-column align-items-center'}>
              <Form className="align-items-center format50 m-format100">
                <Box mb={2}>
                  <Field
                    type="email"
                    name="email"
                    placeholder={
                      languageData === 'EN'
                        ? 'Enter your email address to get started'
                        : 'Ingresa tu correo electrónico para comenzar'
                    }
                    className={
                      'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 fontWhite outlineNone'
                    }
                    style={{
                      backgroundColor: 'rgba(255,255,255,0)',
                      border:
                        errors.email && touched.email
                          ? '2px solid #ff4d4f'
                          : '2px solid rgba(255,255,255,0.4)',
                      transition: 'all 0.2s ease',
                    }}
                    onBlur={e => {
                      e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="padt10 text-15 fontRed100"
                  />
                </Box>
                <Box mb={2} position="relative">
                  <Field
                    type="password"
                    name="password"
                    placeholder={
                      languageData === 'EN'
                        ? 'Create a secure password'
                        : 'Crea una contraseña segura'
                    }
                    className={
                      'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 outlineNone fontWhite'
                    }
                    style={{
                      backgroundColor: 'rgba(255,255,255,0)',
                      border:
                        errors.password && touched.password
                          ? '2px solid #ff4d4f'
                          : '2px solid rgba(255,255,255,0.4)',
                      transition: 'all 0.2s ease',
                    }}
                    onBlur={e => {
                      e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="padt10 text-15 fontRed100"
                  />
                </Box>

                <Box mb={2}>
                  <Field
                    type="text"
                    name="name"
                    placeholder={
                      languageData === 'EN'
                        ? 'Enter your name'
                        : 'Ingresa tu nombre'
                    }
                    className={
                      'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 fontWhite outlineNone'
                    }
                    style={{
                      backgroundColor: 'rgba(255,255,255,0)',
                      border:
                        errors.name && touched.name
                          ? '2px solid #ff4d4f'
                          : '2px solid rgba(255,255,255,0.4)',
                      transition: 'all 0.2s ease',
                    }}
                    onBlur={e => {
                      e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="padt10 text-15 fontRed100"
                  />
                </Box>

                <Box mb={3}>
                  <Field
                    type="text"
                    name="lastname"
                    placeholder={
                      languageData === 'EN'
                        ? 'Enter your last name'
                        : 'Ingresa tu apellido'
                    }
                    className={
                      'border-rad8px grayShadowBottom placeholder-custom boxSizing_borderBox pad14 width100 text-15 fontWhite outlineNone'
                    }
                    style={{
                      backgroundColor: 'rgba(255,255,255,0)',
                      border:
                        errors.lastname && touched.lastname
                          ? '2px solid #ff4d4f'
                          : '2px solid rgba(255,255,255,0.4)',
                      transition: 'all 0.2s ease',
                    }}
                    onBlur={e => {
                      e.target.style.backgroundColor = 'rgba(255,255,255,0.12)';
                      e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                      e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                    }}
                  />
                  <ErrorMessage
                    name="lastname"
                    component="div"
                    className="padt10 text-15 fontRed100"
                  />
                </Box>

                <Button
                  className={'bgGradientSignUpPurple'}
                  type="submit"
                  fullWidth
                  sx={{
                    mt: '8px',
                    py: 0.8,
                    color: 'white',
                    borderRadius: '10px',
                    textTransform: 'none',
                    transition: 'all 0.2s ease',
                    fontSize: '20px',
                    '&:hover': {
                      boxShadow: '0 6px 16px rgba(248, 87, 166, 0.5)',
                      transform: 'translateY(-1px)',
                    },
                    '&:disabled': {
                      opacity: 0.7,
                    },
                  }}
                  disabled={loading || isSubmitting}
                >
                  {loading
                    ? languageData === 'EN'
                      ? 'Loading...'
                      : 'Cargando...'
                    : languageData === 'EN'
                      ? 'Register now'
                      : 'Registrarse ahora'}
                </Button>
                {error && (
                  <Box className="fontRed100 margt20 text-center text-weight-800">
                    {error}
                  </Box>
                )}
                {googleError && (
                  <Label className="text-16 fontRed075 text-center text-weight-800">
                    <i
                      className="fa-solid fa-circle-exclamation"
                      style={{ marginRight: 8 }}
                    ></i>
                    {googleError}
                  </Label>
                )}

                <Box display="flex" alignItems="center" justifyContent="center">
                  <Divider
                    sx={{
                      flexGrow: 1,
                      borderColor: 'rgba(255,255,255,0.25)',
                      borderWidth: 1,
                    }}
                  />
                  <Typography
                    variant="body2"
                    className={'padl16 padr16 '}
                    sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '13px',
                      fontWeight: 500,
                    }}
                  >
                    {languageData === 'EN' ? 'OR' : 'O'}
                  </Typography>
                  <Divider
                    sx={{
                      flexGrow: 1,
                      borderColor: 'rgba(255,255,255,0.25)',
                      borderWidth: 1,
                    }}
                  />
                </Box>
                <FlexContainer className={'width100 justify-center'}>
                  <div
                    style={{
                      maxWidth: '330px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <GoogleLogin
                      onSuccess={handleSuccess}
                      onError={handleError}
                      useOneTap
                      theme="outline"
                      shape="pill"
                      size="large"
                      text="continue_with"
                      width="330"
                      logo_alignment="left"
                    />
                  </div>
                </FlexContainer>
                <FlexContainer
                  className={'justify-between margt30 padlr30 d-hide'}
                >
                  <FlexContainer className={'flex-column width100'}>
                    <Label>
                      {languageData === 'EN'
                        ? 'Already have an'
                        : '¿Ya tienes una'}
                    </Label>
                    <Label>
                      {languageData === 'EN' ? 'account?' : 'cuenta?'}{' '}
                    </Label>
                  </FlexContainer>
                  <Link
                    to={languageData === 'EN' ? '/login' : '/iniciar-sesion'}
                    className={'loginText width100'}
                  >
                    {languageData === 'EN' ? 'Log In' : 'Iniciar sesión'}
                  </Link>
                </FlexContainer>
                <FlexContainer className={'justify-center margt30 m-hide'}>
                  <FlexContainer className={'width100 justify-center'}>
                    <Label className={'text-center'}>
                      {languageData === 'EN'
                        ? 'Already have an account?'
                        : '¿Ya tienes una cuenta?'}{' '}
                      <Link
                        to={
                          languageData === 'EN' ? '/login' : '/iniciar-sesion'
                        }
                        className={'loginText'}
                      >
                        {languageData === 'EN' ? 'Log In' : 'Iniciar sesión'}
                      </Link>
                    </Label>
                  </FlexContainer>
                </FlexContainer>
              </Form>
            </FlexContainer>
          )}
        </Formik>
      )}
    </FlexContainer>
  );
};

const SignUpView = props => {
  const {
    initialValues,
    onSubmit,
    onGoogleLogin,
    loading,
    onBack,
    onRegister,
    languageData,
    error,
    googleError,
    success,
    validationSchema,
    showModal,
    goHome,
    closeModal,
    loginType,
  } = props;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, []);

  return (
    <FlexContainer className="flex-column padlr10 justify-start items-center  bgGradientBlue fontWhite">
      {!success && <SearchBar languageData={languageData} onBack={onBack} />}

      <FlexContainer className={'flex-column padlr20 margb10'}>
        {!success && (
          <>
            <FlexContainer
              className={
                'flex-column align-items-center width100 m-hide margt60 margb30'
              }
            >
              <Label className={'text-40 margt10'}>
                <strong>
                  {languageData === 'EN' ? 'Sign up' : 'Registrarse'}
                </strong>
              </Label>
              <Label className={'text-16 margtb10'}>
                {languageData === 'EN'
                  ? "Welcome! Let's set up you account and get you started."
                  : '¡Bienvenido! Configuremos tu cuenta y comencemos.'}
              </Label>
            </FlexContainer>
            <FlexContainer className={'flex-column d-hide'}>
              <Label className={'text-40 margt10'}>
                <strong>
                  {languageData === 'EN' ? 'Sign up' : 'Registrarse'}
                </strong>
              </Label>
              <Label className={'text-16 margtb10'}>
                {languageData === 'EN'
                  ? "Welcome! Let's set up you account and get you started."
                  : '¡Bienvenido! Configuremos tu cuenta y comencemos.'}
              </Label>
            </FlexContainer>
          </>
        )}

        <SignUpForm
          languageData={languageData}
          onBack={onBack}
          initialValues={initialValues}
          onSubmit={onSubmit}
          onGoogleLogin={onGoogleLogin}
          loading={loading}
          onRegister={onRegister}
          googleError={googleError}
          error={error}
          success={success}
          validationSchema={validationSchema}
        />
        <LoginSuccessModal
          open={showModal}
          onClose={closeModal}
          onGoHome={goHome}
          loginType={loginType}
        />
      </FlexContainer>
    </FlexContainer>
  );
};

export default SignUpView;
